import React from 'react';
import { ResponsiveRadar } from '@nivo/radar'
import { useTheme, Box, Typography } from '@mui/material';

const RadarChart = ({ 
  data = [], 
  title = "",
  digit = 0,
  topOffSet = 0,
  bottomOffSet = 0,
  itemWidthOffSet = 0,
  translateXOffSet = 0,
  translateYOffSet = 0,
}) => {
  const theme = useTheme();
  const primaryDark = theme.palette.primary.dark;
  const neutralDark = theme.palette.neutral.dark;
  const textPrimaryColor = theme.palette.text.primary;
    
  if (!data || data.length === 0 || !Array.isArray(data)) {
    return (
      <Box p={1} sx={{ height: '100%', width: '100%' }}>        
        <Typography>Nothing to display</Typography>
      </Box>
    );
  }

  const MARGIN_RIGHT = 50;
  

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      gap={1} 
      sx={{ height: '100%', width: '100%' }}
    >
      {title && 
        <Typography 
          variant="h6" 
          align="center"
        >
          {title}
        </Typography>
      }

      <ResponsiveRadar
        data={data}     
        keys={Object.keys(data[0]).slice(1)}   
        indexBy={Object.keys(data[0])[0]}
        valueFormat={`>-.${digit}f`}
        margin={{ 
          top: 25 + (topOffSet || 0),
          right: MARGIN_RIGHT, 
          bottom: 125 + (bottomOffSet || 0), 
          left: MARGIN_RIGHT, 
        }}
        borderColor={{ from: 'color' }}
        borderWidth={1}
        gridLabelOffset={18}
        dotSize={8}
        dotColor={{ theme: 'background' }}
        dotBorderWidth={2}
        enableDotLabel={true}
        colors={{ scheme: 'set1' }}      
        fillOpacity={0.2}  
        blendMode="normal"
        motionConfig="wobbly"
        legends={[
          {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: -35 + translateXOffSet, 
            translateY: -100 + translateYOffSet,
            itemsSpacing: 0,            
            itemWidth: 100 + itemWidthOffSet,
            itemHeight: 18,
            itemDirection: 'left-to-right',            
            itemTextColor: textPrimaryColor,
            symbolSize: 12,
            symbolShape: 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: textPrimaryColor,
                }
              }
            ]
          }
        ]}
        theme={{
          axis: {
            domain: {
              line: {
                stroke: neutralDark,
              },
            },
            legend: {
              text: {
                fill: textPrimaryColor,
              },
            },
            ticks: {
              line: {
                stroke: neutralDark,
                strokeWidth: 1,
              },
              text: {
                fill: textPrimaryColor,
              },
            },
          },          
          legends: {
            text: {
              fill: textPrimaryColor,
            },
          }, 
          grid: {
            line: {
              stroke: neutralDark,
              strokeWidth: 0.5,
              strokeDasharray: '2 2'
            }
          },
          tooltip: {
            container: {
              background: theme.palette.neutral.light,
              color: theme.palette.text.primary,
              borderRadius: '4px',
              padding: '8px',
            },
          },
          labels: {
            text: {
              fill: textPrimaryColor,
              fontSize: '12px' 
            },
          },
          dots: {
            text: {
              fill: textPrimaryColor,
            },
          },
          totals: {
            text: {
              fill: primaryDark, 
              fontSize: '12px',
            },
          },
        }}      
      />
    </Box>
  );
};

export default RadarChart;
